import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiUser } = FiIcons;

const Header = ({ kindnessId, onShowModal }) => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <motion.header
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="header-bg border-b border-purple/30 sticky top-0 z-50"
    >
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-4 group">
            <div className="clay-button-pink p-4 group-hover:transform group-hover:scale-110 transition-all duration-300">
              <SafeIcon icon={FiHeart} className="text-3xl heart-logo" />
            </div>
            <div>
              <h1 className="text-3xl font-bold gradient-text">Nakamoto Verse</h1>
              <p className="text-sm font-bold kaas-subtitle">KAAS – Kindness as a Service</p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center space-x-4">
            <Link
              to="/"
              className={`nav-link px-6 py-3 transition-all duration-300 font-bold ${
                isActive('/') 
                  ? 'active transform scale-105' 
                  : 'text-text hover:transform hover:scale-105'
              }`}
            >
              Give Kindness
            </Link>
            <Link
              to="/gallery"
              className={`nav-link px-6 py-3 transition-all duration-300 font-bold ${
                isActive('/gallery') 
                  ? 'active transform scale-105' 
                  : 'text-text hover:transform hover:scale-105'
              }`}
            >
              Kindness Gallery
            </Link>
          </nav>

          <div className="flex items-center space-x-3">
            {kindnessId && (
              <button
                onClick={onShowModal}
                className="clay-button-yellow px-4 py-3 flex items-center space-x-2 font-bold hover:transform hover:scale-105 transition-all duration-300 focus-visible"
              >
                <SafeIcon icon={FiUser} className="text-lg text-text" />
                <span className="hidden sm:block">
                  {kindnessId.split('-').slice(0, 2).join('-')}...
                </span>
              </button>
            )}
          </div>
        </div>

        {/* Mobile Navigation */}
        <nav className="md:hidden mt-4 flex justify-center space-x-4">
          <Link
            to="/"
            className={`nav-link px-4 py-2 text-sm transition-all duration-300 font-bold ${
              isActive('/') 
                ? 'active transform scale-105' 
                : 'text-text hover:transform hover:scale-105'
            }`}
          >
            Give Kindness
          </Link>
          <Link
            to="/gallery"
            className={`nav-link px-4 py-2 text-sm transition-all duration-300 font-bold ${
              isActive('/gallery') 
                ? 'active transform scale-105' 
                : 'text-text hover:transform hover:scale-105'
            }`}
          >
            Gallery
          </Link>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;